module.exports = "https://static.zego.com/_next/static/images/ZegoLogoGreen-b859637b7bd8f22fff77dedc01bfbe23.svg";